import PaymentLinkDetails from './PaymentLinkDetails';

export default PaymentLinkDetails;
